var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mp-box',[_c('mp-box',{attrs:{"bg":"white","p":_vm.noPadding ? 0 : 6,"min-h":_vm.hasTab ? _vm.$contentHeightTab : _vm.$contentHeight,"border-left":"1px","border-top":"1px","border-left-color":"gray.100","border-top-color":"gray.100","border-top-left-radius":"md"}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }